// extracted by mini-css-extract-plugin
module.exports = {"contentLang":"LanguageItems_contentLang__3DC3Q","active":"LanguageItems_active__2nM9S"};